import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    return {
      ...data,
      payor_share: props.payorShare,
      payor_discounts: props.payorDiscounts ?? data.payor_discounts,
      treatment_discounts: props.treatmentDiscounts ?? data.treatment_discounts,
      max_discount: props.maxDiscount ?? data.max_discount,
      organization_ids: props.organizationIds ?? data.organization_ids,
      show_description: props.showPlanDescription ?? data.show_description,
      show_final_discount: props.showFinalDiscount ?? data.show_final_discount,
      show_mocked_plans:
        props.showMockedOnEmptyPaymentPlans ?? data.show_mocked_plans,
    }
  }, [
    data,
    props.showMockedOnEmptyPaymentPlans,
    props.payorDiscounts,
    props.treatmentDiscounts,
    props.payorShare,
    props.maxDiscount,
    props.showPlanDescription,
    props.showFinalDiscount,
    props.organizationIds,
  ])
}
